import { City } from '@app/modules/core/interfaces/address';
import { environment as ENV } from '@environment';

export function getDefaultCityByCountry(cities: City[] = []): City {
  const filter = cities.filter(city => city.country_id === ENV.countryInfo.country_id &&
    city.code_iso_2 === ENV.countryInfo.iso_code).sort((a, b) => a.id - b.id);
  return filter && filter[0] ? filter[0] : null;
}
